// import React, { useState } from 'react'
import { Container } from './styles'
import { useEffect, useState } from 'react'

export default function Projects() {
  const [showElement, setShowElement] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowElement(true)
    }, 500) // Mostrar o elemento após meio segundo

    return () => clearTimeout(timer)
  }, [])
  return (
    <Container>
      <>
        {showElement && (
          <div>
            <h2 className='slide-in'>Projects</h2>
          </div>
        )}
      </>
    </Container>
  )
}
